import React, {Fragment, useContext} from "react";
import {Store} from "../../../app/stores/store-root";
import {observer} from "mobx-react-lite";
import {NavLink, useHistory} from "react-router-dom";
import {
    EuiBreadcrumbs,
    EuiButton,
    EuiInMemoryTable,
    EuiPageContent,
    EuiPageContentHeader, EuiPageContentHeaderSection,
    EuiPanel,
    EuiSpacer, EuiText
} from "@elastic/eui";
import {useInMemoryListConfiguration} from "./agents-list-hook";

export const AgentsList = () => {
    const store = useContext(Store);
    const {agentRegistry, agentsByDate, createdByCurrentUser} = store.Agents;
    const history = useHistory();
    const {breadcrumbs, fields, searchSettings, tools}=useInMemoryListConfiguration();

    return (
        <Fragment>
            <EuiPageContent>
                <EuiBreadcrumbs
                    breadcrumbs={breadcrumbs}
                    truncate={false}
                    aria-label="An example of EuiBreadcrumbs"
                />
                <EuiSpacer size="xs"/>
                <EuiPageContentHeader>
                    <EuiPageContentHeaderSection>
                        <EuiText>
                            <h1>Agents & User Profiles</h1>
                            <p>
                                Agents can be Business Admin (*super user*)  , Sending Agents , Receiving Agent cashiers , Receiving Agent Supervisor and Receiving Agent Admin
                            </p>
                        </EuiText>
                    </EuiPageContentHeaderSection>
                    <EuiPageContentHeaderSection>
                        <EuiButton  fill onClick={()=>history.push('/agents/create')}>New User Profile</EuiButton>
                    </EuiPageContentHeaderSection>
                </EuiPageContentHeader>

            </EuiPageContent>
            <EuiSpacer/>
            <EuiPanel paddingSize="l" hasShadow>
                <EuiInMemoryTable items={(store.Users.isReceiveAgent)?createdByCurrentUser:agentsByDate} hasActions={true} columns={fields}  pagination={true} sorting={true}
                                  search={searchSettings}/>
            </EuiPanel>
        </Fragment>
    );
};

export default observer(AgentsList)
